import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gray-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-white mb-6 transition-colors"
          >
            <FiArrowLeft />
            Retour à l'accueil
          </Link>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">
            Conditions Générales de Vente
          </h1>
          <p className="text-gray-300 mt-4 text-lg">
            Dernière mise à jour : 19 janvier 2026
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="prose prose-gray max-w-none">
          
          {/* Section 1 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              1. Présentation
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Le site web ORIMA (ci-après « le Site ») est exploité par ORIMA STORE, 
              société spécialisée dans la vente en ligne de sacs, montres, portefeuilles 
              et accessoires de mode premium.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Les présentes Conditions Générales de Vente (CGV) régissent les relations 
              contractuelles entre ORIMA STORE et tout client effectuant un achat sur le Site.
            </p>
          </section>

          {/* Section 2 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              2. Acceptation des Conditions
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              En passant commande sur notre site, vous acceptez sans réserve les présentes 
              conditions générales de vente. Ces conditions sont accessibles à tout moment 
              sur notre site et prévaudront sur toute autre version ou tout autre document 
              contradictoire.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Nous nous réservons le droit de modifier ces CGV à tout moment. Les CGV 
              applicables sont celles en vigueur à la date de la commande.
            </p>
          </section>

          {/* Section 3 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              3. Produits et Prix
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  3.1 Produits
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Les produits proposés sont ceux qui figurent sur le Site au jour de la 
                  consultation par le client. Nous nous efforçons de présenter les produits 
                  avec la plus grande exactitude possible. Toutefois, les photographies et 
                  descriptions sont fournies à titre indicatif.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  3.2 Prix
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Les prix sont indiqués en Dirhams Marocains (MAD) et sont valables au moment 
                  de la commande. Ils comprennent toutes les taxes applicables. La livraison 
                  est gratuite partout au Maroc.
                </p>
              </div>
            </div>
          </section>

          {/* Section 4 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              4. Commande
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  4.1 Processus de commande
                </h3>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Sélection des produits et ajout au panier</li>
                  <li>Validation du panier</li>
                  <li>Remplissage du formulaire de livraison</li>
                  <li>Validation de la commande</li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  4.2 Confirmation de commande
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Une fois votre commande validée, vous recevrez un récapitulatif par email 
                  ou SMS. La vente ne sera considérée comme définitive qu'après confirmation 
                  de votre commande par nos services.
                </p>
              </div>
            </div>
          </section>

          {/* Section 5 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              5. Paiement
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              ORIMA STORE propose le paiement à la livraison (cash on delivery). Le paiement 
              s'effectue en espèces au moment de la réception de votre commande.
            </p>
            <div className="bg-gray-50 border-l-4 border-gray-900 p-4">
              <p className="text-gray-700 font-medium">
                Mode de paiement accepté :
              </p>
              <ul className="list-disc pl-6 text-gray-700 mt-2">
                <li>Paiement en espèces à la livraison</li>
              </ul>
            </div>
          </section>

          {/* Section 6 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              6. Livraison
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  6.1 Zone de livraison
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Nous livrons partout au Maroc. La livraison est gratuite sans minimum d'achat.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  6.2 Délais de livraison
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Les délais de livraison sont de 1 à 2 jours ouvrables pour les villes principales, 
                  et de 2 à 4 jours pour les autres localités. Ces délais sont donnés à titre 
                  indicatif et peuvent varier selon les circonstances.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  6.3 Réception de la commande
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Il appartient au client de vérifier l'état du colis à la réception. En cas 
                  de dommage apparent, le client doit refuser le colis et contacter immédiatement 
                  notre service client.
                </p>
              </div>
            </div>
          </section>

          {/* Section 7 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              7. Droit de Rétractation et Retours
            </h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  7.1 Délai de rétractation
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Conformément à la loi marocaine, vous disposez d'un délai de 7 jours à compter 
                  de la réception de votre commande pour exercer votre droit de rétractation.
                </p>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  7.2 Conditions de retour
                </h3>
                <p className="text-gray-700 leading-relaxed mb-2">
                  Pour être acceptés, les produits retournés doivent :
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Être dans leur emballage d'origine</li>
                  <li>Être en parfait état (non utilisés, non lavés, non abîmés)</li>
                  <li>Être accompagnés de leur facture d'achat</li>
                  <li>Conserver toutes les étiquettes attachées</li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  7.3 Remboursement
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Le remboursement sera effectué dans un délai de 14 jours suivant la réception 
                  du produit retourné, après vérification de son état.
                </p>
              </div>
            </div>
          </section>

          {/* Section 8 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              8. Garantie et Service Après-Vente
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Tous nos produits bénéficient de la garantie légale de conformité. Si vous 
              constatez un défaut de fabrication ou une non-conformité, veuillez nous 
              contacter dans les plus brefs délais.
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700 font-medium mb-2">Contact Service Client :</p>
              <ul className="text-gray-700 space-y-1">
                <li>Email : contact@orima.ma</li>
                <li>WhatsApp : +212 6 65 07 80 92</li>
                <li>Horaires : 9h - 18h (Lun - Sam)</li>
              </ul>
            </div>
          </section>

          {/* Section 9 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              9. Propriété Intellectuelle
            </h2>
            <p className="text-gray-700 leading-relaxed">
              L'ensemble des éléments du Site (textes, images, vidéos, logos, etc.) sont 
              protégés par le droit de la propriété intellectuelle. Toute reproduction, 
              représentation, modification, publication ou adaptation totale ou partielle 
              des éléments du Site est strictement interdite sans autorisation écrite 
              préalable d'ORIMA STORE.
            </p>
          </section>

          {/* Section 10 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              10. Protection des Données Personnelles
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les informations collectées lors de votre commande sont nécessaires au traitement 
              de celle-ci. Ces données sont conservées de manière sécurisée et ne sont en aucun 
              cas transmises à des tiers sans votre consentement.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Conformément à la loi 09-08, vous disposez d'un droit d'accès, de rectification 
              et de suppression de vos données personnelles. Pour exercer ce droit, contactez-nous 
              à : contact@orima.ma
            </p>
          </section>

          {/* Section 11 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              11. Responsabilité
            </h2>
            <p className="text-gray-700 leading-relaxed">
              ORIMA STORE ne saurait être tenue responsable de l'inexécution du contrat en cas 
              de force majeure, de perturbation ou de grève totale ou partielle des services 
              postaux et moyens de transport et/ou communications, d'inondation, d'incendie.
            </p>
          </section>

          {/* Section 12 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              12. Litiges
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les présentes CGV sont régies par le droit marocain. En cas de litige, une solution 
              amiable sera recherchée avant toute action judiciaire.
            </p>
            <p className="text-gray-700 leading-relaxed">
              À défaut de résolution amiable, le litige sera porté devant les tribunaux compétents 
              du Royaume du Maroc.
            </p>
          </section>

          {/* Section 13 */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              13. Contact
            </h2>
            <div className="bg-gray-900 text-white p-6 rounded-lg">
              <p className="font-semibold text-lg mb-4">ORIMA STORE</p>
              <div className="space-y-2 text-gray-300">
                <p>Email : contact@orima.ma</p>
                <p>WhatsApp : +212 6 65 07 80 92</p>
                <p>Instagram : @orima_ma</p>
                <p>TikTok : @orima.ma1</p>
              </div>
            </div>
          </section>

        </div>

        {/* Back to home button */}
        <div className="text-center mt-12 pt-8 border-t border-gray-200">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-gray-900 text-white px-8 py-3 rounded-full font-semibold hover:bg-gray-800 transition-all"
          >
            <FiArrowLeft />
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Terms;
